<template>
  <div
      :selected="selected"
      class="
      selectable-trr
      tw-flex tw-justify-between
      tw-bg-white tw-cursor-pointer
      tw-px-small tw-py-small+ tw-mb-small+

      tw-rounded-[20px]"

      :style="{'outline': selected ? '2px solid #1EA89C' : 'none'}"

      @click="toggle"
  >
    <div
        class="
          selectable-trr__select
          tw-w-[20px] tw-mr-small"
    >
      <div
          class="
          radio-outer
          tw-w-[20px] tw-h-[20px]
          tw-rounded-[50%] tw-border-[1px] tw-border-tzz-dark-gray"
      >
        <transition appear name="selected-animate">
          <div
              v-if="selected"
              class="
              radio-inner
              tw-w-[10px] tw-h-[10px] tw-relative tw-top-[4px] tw-left-[4px]
              tw-rounded-[50%] tw-bg-tzz-blue"
          >
          </div>
        </transition>
      </div>
    </div>

    <div
        class="selectable-trr__content
        tw-w-full"
    >
      <p
          class="
          selectable-trr__content-iban tw-font-sans tw-text-tzz-dark-gray tw-text-[15px] tw-leading-[25px] tw-font-bold"
      >
        {{ trrInfo.iban }}
      </p>
      <p
          class="
          selectable-trr__content-owner tw-font-sans tw-text-tzz-dark-gray tw-text-[15px] tw-leading-[25px]"
      >
        {{ trrInfo.ownerFullName }}
      </p>
      <p
          class="
          selectable-trr__content-bank tw-font-sans tw-text-tzz-dark-gray tw-text-[15px] tw-leading-[25px]"
      >
        {{ trrInfo.bankName }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "UISelectableTRR",
  props: {
    trrInfo: {
      type: Object,
      required: true,
      validate: (value) => {
        return typeof value === 'object' && value.iban && value.ownerFullName && value.bankName;
      }
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle', this.trrInfo);
    }
  }
}
</script>

<style scoped>

.selected-animate-enter-active,
.selected-animate-leave-active {
  transition: all 0.3s ease-out;
}

.selected-animate-enter,
.selected-animate-leave-to {
  transform: scale(0);
  opacity: 0;
}


</style>
